// extracted by mini-css-extract-plugin
export var button = "_cc-4";
export var hasDarkBackground = "_cc-7";
export var hasLightBackground = "_cc-6";
export var iconWrapper = "_cc-0";
export var large = "_cc-2";
export var medium = "_cc-1";
export var small = "_cc-5";
export var xsmall = "_cc-3";